export type Income = {
  type: string,
  amount: number,
  frequency: string,
  startDate?: [string, string],
  endDate?: [string, string],
  yearround?: boolean,
}

export function annualize(income: Income): number {
  // console.log(`income dates: ${JSON.stringify(income)}, ${income.startDate}, ${income.endDate}`);
  const useDates = !income.yearround && income.startDate && income.endDate;
  const currentYear = new Date().getFullYear();
  switch (income.frequency) {
    case "weekly":
      if (useDates) {
        const seconds = new Date(`${currentYear}-${income.endDate![0]}-${income.endDate![1]}`).getTime() -
                    new Date(`${currentYear}-${income.startDate![0]}-${income.startDate![1]}`).getTime();
        return (income.amount * Math.round(seconds / (1000 * 60 * 60 * 24 * 7)));
      }
      return income.amount * 52;
    case "biweekly":
      if (useDates) {
        const seconds = new Date(`${currentYear}-${income.endDate![0]}-${income.endDate![1]}`).getTime() -
                    new Date(`${currentYear}-${income.startDate![0]}-${income.startDate![1]}`).getTime();
        return (income.amount * Math.round(seconds / (1000 * 60 * 60 * 24 * 14)));
      }
      return income.amount * 26;
    case "monthly":
      if (useDates) {
        const seconds = new Date(`${currentYear}-${income.endDate![0]}-${income.endDate![1]}`).getTime() -
                    new Date(`${currentYear}-${income.startDate![0]}-${income.startDate![1]}`).getTime();
        return (income.amount * Math.round(seconds / (1000 * 60 * 60 * 24 * 30)));
      }
      return income.amount * 12;
    case "yearly":
    case "one_time":
      return income.amount;
    default:
      return 0;
  }
}
